import { render, staticRenderFns } from "./price-worth-it.vue?vue&type=template&id=0b9884ca&"
import script from "./price-worth-it.vue?vue&type=script&lang=js&"
export * from "./price-worth-it.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports